import {Component, inject, Input, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {KtTripService} from '../service/kt-trip.service';
import {IKtServiceDetail} from '../interfaces/kt-trip.interface';

@Component({
  selector: 'app-kt-service-detail',
  templateUrl: './kt-service-detail.component.html',
  standalone: false,
})
export class KtServiceDetailComponent implements OnInit {
  @Input() public data: any;

  private readonly route = inject(ActivatedRoute);
  private readonly tripService = inject(KtTripService);

  protected readonly service = signal<IKtServiceDetail | null>(null);

  public ngOnInit(): void {
    const id = this.data != null ? Number(this.data) : Number(this.route.snapshot.paramMap.get('id'));
    this.tripService.getServiceById(id).subscribe(s => this.service.set(s));
  }
}
